import { useMemo } from "react";
import intl from "react-intl-universal";
import qs from "qs";
import { useHistory, useLocation } from "react-router-dom";
import { PageHeaderWithBack } from "../../../../Components/Molecules";
import { useToast } from "../../../../Hooks/toast";
import { BaasEntidadeCreateForm } from "./components/BaasEntidadeCreateForm";

const ENTIDADES_LIST_PATH = "/baas/entidades";
const ENTIDADES_CREATE_PATH = "/baas/entidades/nova";

const isQueryTruthy = (value) =>
  value === true || value === "true" || value === "1" || value === "on";

const resolveDebugConsoleExpanded = (search) => {
  const parsed = qs.parse(search.replace("?", ""));
  return isQueryTruthy(parsed.json);
};

const buildEntityDetailPath = (entityId) =>
  `/baas/entidades/${encodeURIComponent(entityId)}`;

export const BaasEntidadeCreatePage = () => {
  const history = useHistory();
  const location = useLocation();
  const { addToast } = useToast();

  const debugConsoleExpanded = useMemo(
    () => resolveDebugConsoleExpanded(location.search),
    [location.search],
  );

  const handleCreated = (result) => {
    const entityId = String(result?.entity?.id || result?.raw?.id || "").trim();
    const owners =
      result?.raw?.business_details?.beneficial_owners ||
      result?.raw?.beneficial_owners ||
      [];
    const partnerIds = (Array.isArray(owners) ? owners : [])
      .map((owner) => String(owner?.pers_id || owner?.persId || "").trim())
      .filter((id) => id.toLowerCase().startsWith("pers_"));

    const detailPath = entityId ? buildEntityDetailPath(entityId) : null;
    addToast({
      type: "success",
      title: intl.get("baas.entidades.create.success"),
      description:
        partnerIds.length > 0
          ? intl.get("baas.entidades.create.successOpenPartners", {
              ids: partnerIds.join(", "),
            })
          : undefined,
      linkTo: detailPath || undefined,
      linkLabel: detailPath
        ? intl.get("baas.entidades.detail.pageTitle")
        : undefined,
    });

    if (detailPath) {
      history.push(detailPath, {
        entityCreated: true,
        createdPartnerIds: partnerIds,
      });
      return;
    }
    history.push(ENTIDADES_LIST_PATH, { entityCreated: true });
  };

  return (
    <div className="baas-entidade-create w-full min-w-0">
      <PageHeaderWithBack
        title={intl.get("baas.entidades.create.pageTitle")}
        subTitle={intl.get("baas.entidades.create.subtitle")}
        backTo={ENTIDADES_LIST_PATH}
      />

      <BaasEntidadeCreateForm
        active
        debugConsoleExpanded={debugConsoleExpanded}
        variant="full"
        onCreated={handleCreated}
      />
    </div>
  );
};

export { ENTIDADES_CREATE_PATH, ENTIDADES_LIST_PATH };
